<script setup lang="ts">
definePageMeta({
  layout: 'legal-area-layout',
})
const router = useRouter().currentRoute
const currentSlug = computed(() => router?.value?.params?.slug)

const { tabs, pageContent } = await useLegalArea('legal-area-pages')
const tabsList = computed(
  () => tabs.value?.map(tab => tab?.url?.target?.target) ?? []
)

if (!tabsList.value?.includes(currentSlug.value as string)) {
  throw showError({
    statusCode: 404,
    statusMessage: 'Page Not Found',
    fatal: true,
  })
}
</script>

<template>
  <LegalArea v-if="pageContent" :data="pageContent" />
</template>
